import { render, staticRenderFns } from "./LabelFirmwareUploader.vue?vue&type=template&id=34fad07e&scoped=true&"
import script from "./LabelFirmwareUploader.vue?vue&type=script&lang=js&"
export * from "./LabelFirmwareUploader.vue?vue&type=script&lang=js&"
import style0 from "./LabelFirmwareUploader.vue?vue&type=style&index=0&id=34fad07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fad07e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VFileInput,VRadio,VRadioGroup,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34fad07e')) {
      api.createRecord('34fad07e', component.options)
    } else {
      api.reload('34fad07e', component.options)
    }
    module.hot.accept("./LabelFirmwareUploader.vue?vue&type=template&id=34fad07e&scoped=true&", function () {
      api.rerender('34fad07e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Firmware/modal/LabelFirmwareUploader.vue"
export default component.exports